// Core
import React, { FC } from 'react';
import { createPortal } from 'react-dom';
// Parts
import Table, { TableApiParamsType, TableHashCacheType } from "../../../components/Table";
// Engine
import { axiosAPI } from "../../../../engine/config/axios";

const Widgets:FC<TableHashCacheType> = (props) => {
  const { hashCache } = props;
  const gridParams = {
    grids: [{ name: 'widgets', hashCache }],
  }

  const apiParams: TableApiParamsType = (loadOptions, pageParams) => ({
      filters: loadOptions?.filter,
      sort: loadOptions?.sort,
      ...pageParams
    });

  return <Table
    api={axiosAPI.settings.widgets.table}
    apiParams={apiParams}
    gridParams={gridParams}
    gridName="widgets"
    sortingMode="multiple"
  />;
}

function WidgetsPortal({ id }: { id: string }) {
  const Root = document.getElementById(id);
  return Root ? createPortal(<Widgets hashCache={Root?.dataset.hashCache} />, Root) : null;
}

export default WidgetsPortal;
